import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
import { InfoIcon } from 'lucide-react';
export function UserManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  // Form State
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    nid: '',
    role: '',
    station: '',
    permissions: {
      approveBeneficiaries: false,
      issuePermits: false,
      manageVessels: false,
      fileCases: false
    }
  });
  const users = [{
    name: 'Rahim Uddin',
    role: 'Range Officer',
    station: 'Chandpai Range',
    status: 'active' as const,
    lastActive: '2024-03-30 10:30'
  }, {
    name: 'Karim Sheikh',
    role: 'Station Officer',
    station: 'Katka Station',
    status: 'active' as const,
    lastActive: '2024-03-30 09:15'
  }, {
    name: 'Fatema Begum',
    role: 'Field Officer',
    station: 'Dhangmari Station',
    status: 'active' as const,
    lastActive: '2024-03-30 08:45'
  }, {
    name: 'Abdul Hakim',
    role: 'HQ Admin',
    station: 'Headquarters',
    status: 'active' as const,
    lastActive: '2024-03-29 16:20'
  }, {
    name: 'Jamal Hossain',
    role: 'Field Officer',
    station: 'Harbaria Station',
    status: 'suspended' as const,
    lastActive: '2024-03-25 14:30'
  }];
  const columns = [{
    key: 'name',
    label: 'Name'
  }, {
    key: 'role',
    label: 'Role'
  }, {
    key: 'station',
    label: 'Station/Range'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-2966" data-mp="3muqv5stvkcdn" />
  }, {
    key: 'lastActive',
    label: 'Last Active'
  }];
  const filters = [{
    key: 'role',
    label: 'Filter by Role',
    options: ['HQ Admin', 'Range Officer', 'Station Officer', 'Field Officer']
  }, {
    key: 'station',
    label: 'Filter by Station',
    options: ['Chandpai Range', 'Katka Station', 'Dhangmari Station', 'Harbaria Station']
  }, {
    key: 'status',
    label: 'Filter by Status',
    options: ['Active', 'Suspended', 'Inactive']
  }];
  const wizardSteps = [{
    title: 'Basic Info',
    description: 'Enter user basic information'
  }, {
    title: 'Role Assignment',
    description: 'Assign role and permissions'
  }, {
    title: 'Review & Confirm',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-2967" data-mp="p47jjrb2fo44">
      <div data-id="element-2968" data-mp="p58t1rcfo2jq">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2969" data-mp="p4zbms5gf3pn">User Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2970" data-mp="l3dqykmohl4w">
          Manage system users and their roles
        </p>
      </div>

      {/* Role-based visibility info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3" data-id="element-2971" data-mp="ezhdpacjjzum">
        <InfoIcon className="text-blue-600 flex-shrink-0 mt-0.5" size={20} data-id="element-2972" data-mp="18m9ibczm6xd" />
        <div className="text-sm text-blue-900" data-id="element-2973" data-mp="66nu50q2aeay">
          <strong data-id="element-2974" data-mp="65cqr20j38kd">Role-Based Access:</strong> Users will only see features and
          data relevant to their assigned role and station.
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-2975" data-mp="3sf6tjb4mkekw">
        <div className="flex gap-4" data-id="element-2976" data-mp="3sbrhyia5tno8">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2977" data-mp="3ef4juc6h0rgq">
            User List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2978" data-mp="1hlkj6am8x3ib">
            Add User
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'list' ? <DataTable columns={columns} data={users} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} searchPlaceholder="Search users..." data-id="element-2979" data-mp="2zown03t4ljol" /> : <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.email || !formData.role) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`User ${formData.fullName} created successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      // Reset form
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        nid: '',
        role: '',
        station: '',
        permissions: {
          approveBeneficiaries: false,
          issuePermits: false,
          manageVessels: false,
          fileCases: false
        }
      });
    }} data-id="element-2980" data-mp="2kzs56nq8thh0">
          {currentStep === 0 && <div className="space-y-4" data-id="element-2981" data-mp="7udeaie9syzu">
              <div className="grid grid-cols-2 gap-4" data-id="element-2982" data-mp="ct6q86dwshxw">
                <div data-id="element-2983" data-mp="crdewdscp9jk">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2984" data-mp="cr3r8wus3eh1">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2985" data-mp="3gaf4kg9fgznv" />
                </div>
                <div data-id="element-2986" data-mp="x69l36g9l618">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2987" data-mp="x5rqsfd5x1vy">
                    Email *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2988" data-mp="4gkhqmg30twg" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2989" data-mp="1xc3k9vpll8rq">
                <div data-id="element-2990" data-mp="21ervub5p4tse">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2991" data-mp="21f9q528ssxxo">
                    Phone Number *
                  </label>
                  <input type="tel" required value={formData.phone} onChange={e => setFormData({
              ...formData,
              phone: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2992" data-mp="1ngtjfbaxr7fj" />
                </div>
                <div data-id="element-2993" data-mp="2bauwtdotamdr">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2994" data-mp="2z2iinh77v796">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2995" data-mp="33ua79m6tb2wo" />
                </div>
              </div>
            </div>}
          {currentStep === 1 && <div className="space-y-4" data-id="element-2996" data-mp="1hqij1qq822t0">
              <div data-id="element-2997" data-mp="1hrjx842jb5ey">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2998" data-mp="1dp5b9b3kjpjg">
                  Role *
                </label>
                <select required value={formData.role} onChange={e => setFormData({
            ...formData,
            role: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2999" data-mp="18qvgh1lraqyd">
                  <option value="" data-id="element-3000" data-mp="2dxvdg33lx759">Select Role</option>
                  <option value="hq" data-id="element-3001" data-mp="2hyf54r5evik0">HQ Admin</option>
                  <option value="range" data-id="element-3002" data-mp="2hxniw6xpex6e">Range Officer</option>
                  <option value="station" data-id="element-3003" data-mp="2mqp40woi7syf">Station Officer</option>
                  <option value="field" data-id="element-3004" data-mp="2roqkd9ujpe67">Field Officer</option>
                </select>
              </div>
              <div data-id="element-3005" data-mp="2wnl5iifzjeth">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3006" data-mp="2wn1wjr8bc0rl">
                  Assigned Station/Range *
                </label>
                <select required value={formData.station} onChange={e => setFormData({
            ...formData,
            station: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3007" data-mp="31ktlccdnv6rk">
                  <option value="" data-id="element-3008" data-mp="24kl5ih5dbh9t">Select Station/Range</option>
                  <option value="chandpai" data-id="element-3009" data-mp="24mxtpc1pynvb">Chandpai Range</option>
                  <option value="katka" data-id="element-3010" data-mp="29imkoqzoawg0">Katka Station</option>
                  <option value="dhangmari" data-id="element-3011" data-mp="2ejtt8s9n3znq">Dhangmari Station</option>
                  <option value="harbaria" data-id="element-3012" data-mp="2egxw365m9f0c">Harbaria Station</option>
                </select>
              </div>
              <div data-id="element-3013" data-mp="2njz091ax8w1d">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3014" data-mp="2njgyxq9ejrml">
                  Permissions
                </label>
                <div className="space-y-2" data-id="element-3015" data-mp="2sb8n5u535l9k">
                  <label className="flex items-center gap-2" data-id="element-3016" data-mp="2x9ikobea8xyc">
                    <input type="checkbox" checked={formData.permissions.approveBeneficiaries} onChange={e => setFormData({
                ...formData,
                permissions: {
                  ...formData.permissions,
                  approveBeneficiaries: e.target.checked
                }
              })} className="w-4 h-4 text-[#1B5E20] rounded focus:ring-[#1B5E20]" data-id="element-3017" data-mp="2x90dwktzv1c6" />
                    <span className="text-sm text-gray-700" data-id="element-3018" data-mp="gpg9glht24ag">
                      Approve Beneficiaries
                    </span>
                  </label>
                  <label className="flex items-center gap-2" data-id="element-3019" data-mp="19brbm0l28d9d">
                    <input type="checkbox" checked={formData.permissions.issuePermits} onChange={e => setFormData({
                ...formData,
                permissions: {
                  ...formData.permissions,
                  issuePermits: e.target.checked
                }
              })} className="w-4 h-4 text-[#1B5E20] rounded focus:ring-[#1B5E20]" data-id="element-3020" data-mp="14law8axoihkd" />
                    <span className="text-sm text-gray-700" data-id="element-3021" data-mp="3rjmz03k51qr6">Issue Permits</span>
                  </label>
                  <label className="flex items-center gap-2" data-id="element-3022" data-mp="3cr375z2fv5p1">
                    <input type="checkbox" checked={formData.permissions.manageVessels} onChange={e => setFormData({
                ...formData,
                permissions: {
                  ...formData.permissions,
                  manageVessels: e.target.checked
                }
              })} className="w-4 h-4 text-[#1B5E20] rounded focus:ring-[#1B5E20]" data-id="element-3023" data-mp="3hqfv6n51qit7" />
                    <span className="text-sm text-gray-700" data-id="element-3024" data-mp="x0gsas2uyzxg">
                      Manage Vessels
                    </span>
                  </label>
                  <label className="flex items-center gap-2" data-id="element-3025" data-mp="2ckr6nyrl5yjr">
                    <input type="checkbox" checked={formData.permissions.fileCases} onChange={e => setFormData({
                ...formData,
                permissions: {
                  ...formData.permissions,
                  fileCases: e.target.checked
                }
              })} className="w-4 h-4 text-[#1B5E20] rounded focus:ring-[#1B5E20]" data-id="element-3026" data-mp="2cmaj1ea4fpg9" />
                    <span className="text-sm text-gray-700" data-id="element-3027" data-mp="35apz844zodt6">File Cases</span>
                  </label>
                </div>
              </div>
            </div>}
          {currentStep === 2 && <div className="space-y-6" data-id="element-3028" data-mp="1awyg8e0rshl2">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3029" data-mp="1yfgs771hrey">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-3030" data-mp="1xxa0gmr3uss">
                  Basic Information
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3031" data-mp="6zmne2xg4kk1">
                  <div data-id="element-3032" data-mp="bxxyegzh913u">
                    <span className="text-gray-600" data-id="element-3033" data-mp="bxehn3lkcire">Name:</span>{' '}
                    <span className="font-medium" data-id="element-3034" data-mp="fx6nh8jkoat2">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3035" data-mp="3kc6kd67hutn1">
                    <span className="text-gray-600" data-id="element-3036" data-mp="3kbn3lstkybal">Email:</span>{' '}
                    <span className="font-medium" data-id="element-3037" data-mp="3oe1glwakigty">
                      {formData.email || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3038" data-mp="3t6b475o7n4t2">
                    <span className="text-gray-600" data-id="element-3039" data-mp="3t6ky34cdlw41">Phone:</span>{' '}
                    <span className="font-medium" data-id="element-3040" data-mp="2wmc6qmfcp11q">
                      {formData.phone || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3041" data-mp="2t5g3vjtf14ai">
                    <span className="text-gray-600" data-id="element-3042" data-mp="2t3v51i02iz6u">NID:</span>{' '}
                    <span className="font-medium" data-id="element-3043" data-mp="2o638gaohaowb">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3044" data-mp="2f5f11ytlbmse">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-3045" data-mp="2f4vl2nni38h0">
                  Role & Permissions
                </h4>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3046" data-mp="25fc09cg894ji">
                  <div data-id="element-3047" data-mp="25dslxre4t3kd">
                    <span className="text-gray-600" data-id="element-3048" data-mp="25dis1spyuc9e">Role:</span>{' '}
                    <span className="font-medium capitalize" data-id="element-3049" data-mp="20gsbl4a91eng">
                      {formData.role || 'Not selected'}
                    </span>
                  </div>
                  <div data-id="element-3050" data-mp="1rfu5mgg92x28">
                    <span className="text-gray-600" data-id="element-3051" data-mp="1re9el0t59w94">Station:</span>{' '}
                    <span className="font-medium capitalize" data-id="element-3052" data-mp="1mg7ss84c3ity">
                      {formData.station || 'Not selected'}
                    </span>
                  </div>
                  <div className="col-span-2" data-id="element-3053" data-mp="1hrymqfwl0r08">
                    <span className="text-gray-600" data-id="element-3054" data-mp="1hsq8z04ahcdu">Permissions:</span>{' '}
                    <span className="font-medium" data-id="element-3055" data-mp="12v7pac6gxpd9">
                      {Object.entries(formData.permissions).filter(([_, val]) => val).map(([key]) => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())).join(', ') || 'None selected'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}